import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { IoIosNotifications, IoMdClose } from 'react-icons/io';
import { FaExternalLinkAlt, FaRegEdit } from 'react-icons/fa';
import { GoRead } from 'react-icons/go';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';
import CustomButton from '../CustomButton/CustomButton';
import CustomModal from '../CustomModal/CustomModal';

type NotificationModel = {
  id: number;
  title: string;
  description: string;
  url: string;
  notificationDate: string;
  readAt: string;
};

export default function NotificatioList() {
  const [isShow, setIsShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notifications, setNotifications] = useState<NotificationModel[]>([]);

  const {
    user: { organization },
  } = useAuth();

  const getNotifications = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get(
        `organizations/${organization.id}/notifications`
      );
      setNotifications(data.data);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleNotifications = () => {
    setIsShow(!isShow);
  };

  const forceMarkAsRead = async (notification: NotificationModel) => {
    try {
      await api.post(
        `organizations/${organization.id}/notifications/${notification.id}/mark-as-read`
      );

      getNotifications();
    } catch (e) {
      console.log(e);
    }
  };

  const markAsRead = async (notification: NotificationModel) => {
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(
        'Você deseja marcar a notificação como lida? Essa ação não poderá ser desfeita'
      )
    ) {
      forceMarkAsRead(notification);
    }
  };

  useEffect(() => {
    if (isShow) {
      getNotifications();
    }
  }, [isShow]);

  useEffect(() => {
    getNotifications();
  }, []);

  return (
    <div className='ms-3 me-3'>
      <button
        type='button'
        className='btn position-relative p-0 btn-lg text-white'
        onClick={toggleNotifications}
      >
        <IoIosNotifications size={25} />
        {notifications.filter((n) => !n.readAt).length > 0 && (
          <span
            className='position-absolute start-100 translate-middle badge rounded-pill bg-danger'
            style={{ top: '5px', fontSize: '.7rem' }}
          >
            {notifications.filter((n) => !n.readAt).length > 99
              ? '99+'
              : notifications.filter((n) => !n.readAt).length}
            <span className='visually-hidden'>unread messages</span>
          </span>
        )}
      </button>
      {isShow && (
        <div className='position-relative'>
          <div
            className='position-absolute border shadow bg-light rounded'
            style={{
              zIndex: 1,
              top: '0.5rem',
              right: '-1rem',
              minWidth: '25rem',
            }}
          >
            <div className='d-flex justify-content-end p-2'>
              <button
                type='button'
                className='btn p-0 align-self-start'
                onClick={() => setIsShow(false)}
              >
                <IoMdClose size={20} />
              </button>
            </div>
            {isLoading ? (
              <div className='placeholder-glow'>
                <span className='placeholder placeholder-lg col-12' />
                <span className='placeholder placeholder-xs col-12 bg-dark' />
                <span className='placeholder col-12 bg-secondary' />
                <span className='placeholder col-12 bg-secondary' />
                <span className='placeholder col-12 bg-secondary' />
                <span className='placeholder col-12 bg-secondary' />
                <span className='placeholder col-12 bg-secondary' />
              </div>
            ) : (
              <div
                className='overflow-auto p-1 m-1'
                style={{ maxHeight: '20rem' }}
              >
                {notifications.length > 0 ? (
                  notifications.map((n) => {
                    const notificationDate = new Date(n.notificationDate);
                    return (
                      <div
                        key={n.id}
                        className={`border rounded mb-2 ${
                          n.readAt ? 'bg-white' : 'bg-warning bg-opacity-10'
                        }`}
                      >
                        <div className='d-flex align-items-top p-2 border-bottom gap-2'>
                          <strong className='me-auto'>{n.title}</strong>
                          <div className='d-flex text-end flex-column'>
                            <small>
                              {notificationDate.toLocaleDateString()}
                            </small>
                            <small>
                              {notificationDate.toLocaleTimeString()}
                            </small>
                          </div>
                        </div>
                        <div className='p-2'>
                          {n.url ? (
                            <Link
                              to={n.url}
                              target='_blank'
                              onClick={() => forceMarkAsRead(n)}
                            >
                              {n.description} <FaExternalLinkAlt size={12} />
                            </Link>
                          ) : (
                            n.description
                          )}
                        </div>
                        {!n.readAt && (
                          <div className='d-flex justify-content-end m-2'>
                            <CustomButton
                              type='button'
                              className='btn p-0 mb-1'
                              title='Marcar como lido'
                              handleClick={() => markAsRead(n)}
                            >
                              <GoRead size={20} />
                            </CustomButton>
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div
                    className='d-flex align-items-center justify-content-center border bg-light'
                    style={{ border: 'dashed' }}
                  >
                    <span className='text-center m-3 fw-bold'>
                      Sem notificações
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
